import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import HelpPane from 'components/Common/HelpPane'
import Modal from 'LuxKit/Modal/Modal'
import { INTL_DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import { useIntlDateFormatter } from 'lib/datetime/dateUtils'

interface Props {
  experience: App.ExperienceOffer
  onSupportEmailClick?: () => void
  onSupportNumberClick?: () => void
}

function ExperienceGiveAsGiftInfoModal(props: Props) {
  const { experience, onSupportEmailClick, onSupportNumberClick } = props

  const intl = useIntl()
  const dateFormatter = useIntlDateFormatter()

  const hasDates = !!(experience.bookByDate || experience.expirationDate)

  const bookByDate = dateFormatter(experience.bookByDate ?? experience.expirationDate, INTL_DMY_CASUAL_FORMAT)
  const travelUntilDate = dateFormatter(experience.expirationDate, INTL_DMY_CASUAL_FORMAT)

  const giftInfoText = hasDates
    ? intl.formatMessage(
        {
          id: 'xOh9qPq56JvpK9m23VKv',
          defaultMessage: 'Buy a package and send as a gift to a special someone. They can book by {bookByDate} and travel until {travelUntilDate}.',
        },
        { bookByDate, travelUntilDate },
      )
    : intl.formatMessage({
        id: 'ovFGv47moKUcfe4eLnmX',
        defaultMessage: 'Buy a package and send as a gift to a special someone.',
      })

  return (<Modal title={intl.formatMessage({ id: 'Qxls8oZbPBcJQOFIdKtV', defaultMessage: 'Gifting available' })}>
    <BodyText className="full-width" variant="large">
      {giftInfoText}
    </BodyText>
    <HelpPane
      onSupportEmailClick={onSupportEmailClick}
      onSupportNumberClick={onSupportNumberClick}
    />
  </Modal>)
}

export default ExperienceGiveAsGiftInfoModal
